import { API } from './apiClient';

export function createSessionEventSource() {
  return new EventSource(`${API}/session/events`);
}
